<app-loading-spinner *ngIf="usageLimits == null; else main"></app-loading-spinner>
<ng-template #main>
  <tr class="row mt-4">
    <span class="col-3">Daily Activity Limit</span>
    <div>
      <select class="form-control" [(ngModel)]="usageLimits.DailyActivityLimit">
        <option *ngFor="let value of activityCountLimits" [ngValue]="value">
          {{displayDailyActivityLimit(value)}}
        </option>
      </select>
    </div>
  </tr>
  <tr class="row mt-4">
    <span class="col-3">Furthest Unit</span>
    <div>
      <div>
        <select class="form-control" [(ngModel)]="usageLimits.UnitLimit">
          <option *ngFor="let value of unitLimits" [ngValue]="value.value">
            {{value.name}}
          </option>
        </select>
      </div>
    </div>
  </tr>
  <tr class="row mt-4">
    <span class="col-12">NOTE: There is no Activity Limit for students in the Older Beginner course.</span>
  </tr>
  <app-loading-spinner *ngIf="isSaving"></app-loading-spinner>
  <button *ngIf="!isSaving" class="btn btn-primary" (click)="saveChanges()">Save</button>
</ng-template>
